// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common_style_lease {
  font-family: Inter;
  font-weight: 600;
}

.leaseDeed_Self_Declaration_Heading {
  font-size: 20px;
  letter-spacing: -0.02em;
  color: #3a7425;
}

.leaseDeed_Self_Declaration_paragraph {
  font-size: 16px;
  line-height: 22px;
  color: #000000;
}

.leaseDeed_Self_Declaration_label {
  font-family: Karla;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}

.leaseDeed_Self_Declaration_Signature {
  font-family: Inter;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0px;
}

.leaseDeed_Self_Declaration_note {
  font-family: Karla;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #000000;
}

.lease_email_notification,
.lease_documents_field {
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #45852e;
}

.common_style_lease_paragraph {
  font-size: 14px;
  color: #000000;
}

.sub_head_style {
  color: #0763b8 !important;
  font-size: 14px;
  font-weight: 500;
}

.payment-option {
  border-radius: 8px;
  padding: 8px 12px;
  width: 200px;
  height: 108px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.payment-option img {
  mix-blend-mode: multiply;
}
.payment-option:hover, .payment-option.active {
  border: 1px #8db57e solid;
  background: #f4ffee;
}

.payment-done .details {
  display: flex;
}
.payment-done .details .detail {
  flex-grow: 1;
}
.payment-done .details .detail .head {
  font-size: 14px;
  font-weight: 400;
  counter-reset: rgba(0, 0, 0, 0.8);
}
.payment-done .details .detail .content {
  font-size: 16px;
  font-weight: 500;
  counter-reset: rgba(0, 0, 0, 0.8);
}
.payment-done .details .detail .content.pill {
  border-radius: 15px;
  width: fit-content;
  padding: 2px 20px;
}
.payment-done .details .detail .content.pill.pill-success {
  background: #dfefdc;
  color: #238e1a;
}
.payment-done .details .detail .content.pill.pill-warning {
  background: rgba(var(--bs-warning-rgb), 0.3);
  color: rgb(var(--bs-warning-rgb));
}
.payment-done .details .detail .content.pill.pill-error {
  background: rgba(var(--bs-danger-rgb), 0.3);
  color: rgb(var(--bs-danger-rgb));
}
.payment-done .details .detail .content.link {
  color: #45852e;
  text-decoration: underline;
  cursor: pointer;
}
.payment-done .details .detail .content.link.disabled {
  color: gray;
  pointer-events: none;
}

.border.danger {
  background-color: #fae1e1;
  border: 1px #eb9292 solid;
}
.border.success {
  background-color: #f4ffee;
  border: 1px #8db57e solid;
}
.border.warning {
  background-color: #faf3e1;
  border: 1px #ebd892 solid;
}

.estate-add-btn {
  position: absolute;
  top: 29px;
  right: 0;
  margin-right: 12rem;
  z-index: 9;
}

.table-content-right {
  width: 90px;
  text-align: end;
  border: 1px #8db57e solid;
  border-radius: 5px;
}

.width-12 {
  width: 12%;
}

.width-4 {
  width: 4%;
}

.width-6 {
  width: 6%;
}

.width-2 {
  width: 2%;
}

.width-10 {
  width: 10%;
}

.width-20 {
  width: 20%;
}

.column-text-start-description {
  padding-left: 15px;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/features/modules/EstateManagement/EstateManagement.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;AACJ;;AACA;EACI,eAAA;EACA,uBAAA;EACA,cAAA;AAEJ;;AAAA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;AAGJ;;AADA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAIJ;;AAFA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAKJ;;AAHA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAMJ;;AAJA;;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAOJ;;AALA;EACI,eAAA;EACA,cAAA;AAQJ;;AANA;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;AASJ;;AAPA;EACI,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAUJ;AATI;EACI,wBAAA;AAWR;AATI;EAEI,yBAAA;EACA,mBAAA;AAUR;;AANI;EACI,aAAA;AASR;AARQ;EACI,YAAA;AAUZ;AATY;EACI,eAAA;EACA,gBAAA;EACA,iCAAA;AAWhB;AATY;EACI,eAAA;EACA,gBAAA;EACA,iCAAA;AAWhB;AAVgB;EACI,mBAAA;EACA,kBAAA;EACA,iBAAA;AAYpB;AAXoB;EACI,mBAAA;EACA,cAAA;AAaxB;AAXoB;EACI,4CAAA;EACA,iCAAA;AAaxB;AAXoB;EACI,2CAAA;EACA,gCAAA;AAaxB;AAVgB;EACI,cAAA;EACA,0BAAA;EACA,eAAA;AAYpB;AAXoB;EACI,WAAA;EACA,oBAAA;AAaxB;;AAJI;EACI,yBAAA;EACA,yBAAA;AAOR;AALI;EACI,yBAAA;EACA,yBAAA;AAOR;AALI;EACI,yBAAA;EACA,yBAAA;AAOR;;AAJA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,UAAA;AAOJ;;AAJA;EACI,WAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAOJ;;AAFA;EACI,UAAA;AAKJ;;AAFA;EACI,SAAA;AAKJ;;AAFA;EACI,SAAA;AAKJ;;AAFA;EACI,SAAA;AAKJ;;AAFA;EACI,UAAA;AAKJ;;AAFA;EACI,UAAA;AAKJ;;AAFA;EACI,kBAAA;EACA,gBAAA;AAKJ","sourcesContent":[".common_style_lease {\n    font-family: Inter;\n    font-weight: 600;\n}\n.leaseDeed_Self_Declaration_Heading {\n    font-size: 20px;\n    letter-spacing: -0.02em;\n    color: #3a7425;\n}\n.leaseDeed_Self_Declaration_paragraph {\n    font-size: 16px;\n    line-height: 22px;\n    color: #000000;\n}\n.leaseDeed_Self_Declaration_label {\n    font-family: Karla;\n    font-weight: 400;\n    line-height: 20px;\n    cursor: pointer;\n}\n.leaseDeed_Self_Declaration_Signature {\n    font-family: Inter;\n    font-weight: 500;\n    line-height: 26px;\n    letter-spacing: 0px;\n}\n.leaseDeed_Self_Declaration_note {\n    font-family: Karla;\n    font-size: 14px;\n    font-style: italic;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n    color: #000000;\n}\n.lease_email_notification,\n.lease_documents_field {\n    font-family: Inter;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #45852e;\n}\n.common_style_lease_paragraph {\n    font-size: 14px;\n    color: #000000;\n}\n.sub_head_style {\n    color: #0763b8 !important;\n    font-size: 14px;\n    font-weight: 500;\n}\n.payment-option {\n    border-radius: 8px;\n    padding: 8px 12px;\n    width: 200px;\n    height: 108px;\n    background: #f1f1f1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    img {\n        mix-blend-mode: multiply;\n    }\n    &:hover,\n    &.active {\n        border: 1px #8db57e solid;\n        background: #f4ffee;\n    }\n}\n.payment-done {\n    .details {\n        display: flex;\n        .detail {\n            flex-grow: 1;\n            .head {\n                font-size: 14px;\n                font-weight: 400;\n                counter-reset: rgba(0, 0, 0, 0.8);\n            }\n            .content {\n                font-size: 16px;\n                font-weight: 500;\n                counter-reset: rgba(0, 0, 0, 0.8);\n                &.pill {\n                    border-radius: 15px;\n                    width: fit-content;\n                    padding: 2px 20px;\n                    &.pill-success {\n                        background: #dfefdc;\n                        color: #238e1a;\n                    }\n                    &.pill-warning {\n                        background: rgba(var(--bs-warning-rgb), 0.3);\n                        color: rgb(var(--bs-warning-rgb));\n                    }\n                    &.pill-error {\n                        background: rgba(var(--bs-danger-rgb), 0.3);\n                        color: rgb(var(--bs-danger-rgb));\n                    }\n                }\n                &.link {\n                    color: #45852e;\n                    text-decoration: underline;\n                    cursor: pointer;\n                    &.disabled {\n                        color: gray;\n                        pointer-events: none;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.border {\n    &.danger {\n        background-color: #fae1e1;\n        border: 1px #eb9292 solid;\n    }\n    &.success {\n        background-color: #f4ffee;\n        border: 1px #8db57e solid;\n    }\n    &.warning {\n        background-color: #faf3e1;\n        border: 1px #ebd892 solid;\n    }\n}\n.estate-add-btn {\n    position: absolute;\n    top: 29px;\n    right: 0;\n    margin-right: 12rem;\n    z-index: 9;\n}\n\n.table-content-right {\n    width: 90px;\n    text-align: end;\n    border: 1px #8db57e solid;\n    border-radius: 5px;\n}\n\n//payment-table-width-changes\n\n.width-12 {\n    width: 12%;\n}\n\n.width-4 {\n    width: 4%;\n}\n\n.width-6 {\n    width: 6%;\n}\n\n.width-2 {\n    width: 2%;\n}\n\n.width-10 {\n    width: 10%;\n}\n\n.width-20 {\n    width: 20%;\n}\n\n.column-text-start-description {\n    padding-left: 15px;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
